// useDocumentTitle.js
import { useEffect, useRef } from "react";

const useDocumentTitle = (title, prevailOnUnmount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    // Update the title when the component mounts or the title changes
    document.title = title;
  }, [title]);

  useEffect(() => {
    // Optional: restore the original title when the component unmounts
    return () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle.current;
      }
    };
  }, [prevailOnUnmount]);
};

export default useDocumentTitle;
